import UltMeta, { Meta } from "./UltMeta/index";

class QueryType extends UltMeta {
    SHIPPER = new Meta(1, "船主");
    SHIPOWNER = new Meta(2, "货主");
}

export const QUERY_TYPE = new QueryType();

// 页面tab
class TransportOrderShipPageTabs extends UltMeta {
    BASE = new Meta(0, "基本信息");
    LOADED = new Meta(1, "装货");
    DEPARTURE = new Meta(2, "发航");
    TRANSPORTATION = new Meta(3, "运输");
    DISCHARGED = new Meta(4, "卸货");
}

export const TRANSPORT_ORDER_SHIP_PAGE_TABS = new TransportOrderShipPageTabs();

class FreightSettleTonConfirmNode extends UltMeta {
    AWAITING_DEPARTURE = new Meta(1, "待发航");
    TO_BE_UNLOADED = new Meta(2, "待卸货");
}
export const FREIGHT_SETTLE_TON_CONFIRM_NODE = new FreightSettleTonConfirmNode();

/**
 * 货主船务信息服务费支付状态
 */
class OwnerShipInfoServiceFeeState extends UltMeta {
    UNPAID = new Meta(1, "待支付");
    UN_CONFIRM = new Meta(2, "待确认");
    SUCCESS = new Meta(3, "已支付");
}
export const OWNER_SHIP_INFO_SERVICE_FEE_STATE = new OwnerShipInfoServiceFeeState();
